import SinglePageNationalityView from './SinglePageNationalityView'


export default SinglePageNationalityView
